import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { User } from '../../models/user';
import { GlobalProvider } from '../../providers/global/global';
import { RegisterPage } from '../register/register';

@Component({
  selector: 'page-list',
  templateUrl: 'list.html'
})
export class ListPage {

  lista: string[];
  data: Observable<any>;
  user = {} as User;
  listVisible: boolean = false;
  userVisible: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public global: GlobalProvider) {

    this.global.editarUsuario = "";
    this.global.novoUsuario = "";
    this.global.firstName = "";
    this.global.lastName = "";
    this.global.email = "";
    this.global.userName = "";
  }

  ionViewDidEnter() {
    this.userVisible = false;
    this.listVisible = true;
    this.global.function_list = "0";
    this.global.user = this.global.userId;
    this.user_list();
  }

  pesquisar(user: User) {
    if (user.userName == null || user.userName == "") {
      this.userVisible = false;
      this.listVisible = true;
      this.global.function_list = "0";
      this.global.user = this.global.userId;
      this.user_list();
    }
    else {
      this.listVisible = false;
      this.userVisible = true;
      this.global.function_list = "1";
      this.global.user = user.userName;
      this.user_list();
    }
  }

  public user_list() {
    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/listar_global_users';
      this.global.check_jwt();

      let body = new FormData();
      body.append('userName', this.global.user);
      body.append('function', this.global.function_list);
      body.append('securityLevel', this.global.securityLevel);
      body.append('userId', this.global.userId);
      body.append('userPermissions', this.global.banco);
      body.append('jwt', this.global.token);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        if (data == null) {
          document.getElementById("demo").innerHTML = "Nenhum registro encontrado!";
        }
        else {
          this.lista = data;
        }
      });
    }
    catch (e) {
      console.error(e);
    }
  }

  usuario(user) {
    this.global.editarUsuario = true;
    this.global.novoUsuario = false;

    this.global.firstName = user.firstName;
    this.global.lastName = user.lastName;
    this.global.email = user.email;
    this.global.userName = user.userName;

    for (let i = 0; i < user.areaAccess.split(";").length; i++) {
      this.global.notifCheckBox = (user.areaAccess.split(";")[i] == this.global.banco + "_mg") ? true : false;
      if (this.global.notifCheckBox) { break; }
    }

    this.global.userNotifications = [];
    for (let i = 0; i < user.areaAccess.split(";").length; i++) {
      this.global.userNotifications[i] = user.areaAccess.split(';')[i];
    }

    this.global.level = user.securityLevel;
    this.global.changeSecurity = (user.userName == this.global.userId && this.global.securityLevel > 1) ? false : true;
    this.global.changePassword = (user.userName == this.global.userId || this.global.securityLevel <= 1) ? true : false;
    this.global.hidePass = (this.global.securityLevel == 0 && user.userName != this.global.userId) ? false : true;

    this.global.userPermissions = [];
    for (let i = 0; i < user.userPermissions.split(';').length; i++) {
      this.global.userPermissions[i] = user.userPermissions.split(';')[i];
    }

    this.navCtrl.push(RegisterPage);
  }

  newUser() {
    this.global.firstName = "";
    this.global.lastName = "";
    this.global.email = "";
    this.global.userName = "";
    this.global.novoUsuario = true;
    this.global.editarUsuario = false;
    this.navCtrl.push(RegisterPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts